import { MODULE } from "./constants.mjs";
import { ImportExportSettingsApp } from "../applications/import-export-settings-app.mjs";
import { EveryoneActorTypesTagifyApp, EveryonePropertiesTagifyApp, GmActorTypesTagifyApp, GmPropertiesTagifyApp, PlayerPropertiesTagifyApp } from "../applications/tagify-app.mjs";

export const registerSettings = function() {
  game.settings.registerMenu(MODULE.ID, "gmPropertiesForm", {
    name: game.i18n.localize("changeLog.settings.gmPropertiesForm.name"),
    label: game.i18n.localize("changeLog.settings.gmPropertiesForm.label"),
    hint: game.i18n.localize("changeLog.settings.gmPropertiesForm.hint"),
    icon: "fas fa-ballot-check",
    type: GmPropertiesTagifyApp,
    restricted: true,
    scope: "world"
  });

  /* -------------------------------------------- */

  game.settings.registerMenu(MODULE.ID, "gmActorTypesForm", {
    name: game.i18n.localize("changeLog.settings.gmActorTypesForm.name"),
    label: game.i18n.localize("changeLog.settings.gmActorTypesForm.label"),
    hint: game.i18n.localize("changeLog.settings.gmActorTypesForm.hint"),
    icon: "fas fa-ballot-check",
    type: GmActorTypesTagifyApp,
    restricted: true,
    scope: "world"
  });

  /* -------------------------------------------- */

  game.settings.registerMenu(MODULE.ID, "everyonePropertiesForm", {
    name: game.i18n.localize("changeLog.settings.everyonePropertiesForm.name"),
    label: game.i18n.localize("changeLog.settings.everyonePropertiesForm.label"),
    hint: game.i18n.localize("changeLog.settings.everyonePropertiesForm.hint"),
    icon: "fas fa-ballot-check",
    type: EveryonePropertiesTagifyApp,
    restricted: true,
    scope: "world"
  });

  /* -------------------------------------------- */

  game.settings.registerMenu(MODULE.ID, "everyoneActorTypesForm", {
    name: game.i18n.localize("changeLog.settings.everyoneActorTypesForm.name"),
    label: game.i18n.localize("changeLog.settings.everyoneActorTypesForm.label"),
    hint: game.i18n.localize("changeLog.settings.everyoneActorTypesForm.hint"),
    icon: "fas fa-ballot-check",
    type: EveryoneActorTypesTagifyApp,
    restricted: true,
    scope: "world"
  });

  /* -------------------------------------------- */

  game.settings.registerMenu(MODULE.ID, "playerPropertiesForm", {
    name: game.i18n.localize("changeLog.settings.playerPropertiesForm.name"),
    label: game.i18n.localize("changeLog.settings.playerPropertiesForm.label"),
    hint: game.i18n.localize("changeLog.settings.playerPropertiesForm.hint"),
    icon: "fas fa-ballot-check",
    type: PlayerPropertiesTagifyApp,
    restricted: true,
    scope: "world"
  });

  /* -------------------------------------------- */

  game.settings.registerMenu(MODULE.ID, "importExportForm", {
    name: game.i18n.localize("changeLog.settings.importExportForm.name"),
    label: game.i18n.localize("changeLog.settings.importExportForm.label"),
    hint: game.i18n.localize("changeLog.settings.importExportForm.hint"),
    icon: "fas fa-file-arrow-up",
    type: ImportExportSettingsApp,
    restricted: true,
    scope: "world"
  });

  /* -------------------------------------------- */

  game.settings.register(MODULE.ID, "logDestination", {
    name: game.i18n.localize("changeLog.settings.logDestination.name"),
    hint: game.i18n.localize("changeLog.settings.logDestination.hint"),
    scope: "world",
    config: true,
    type: String,
    default: "chat",
    choices: {
      chat: game.i18n.localize("changeLog.settings.logDestination.chat"),
      journal: game.i18n.localize("changeLog.settings.logDestination.journal"),
      both: game.i18n.localize("changeLog.settings.logDestination.both")
    },
    onChange: () => { game.changeLog.getLogDestination(); }
  });

  /* -------------------------------------------- */

  if ( game.modules.get("custom-chat-tabs")?.active ) {
    game.settings.register(MODULE.ID, "chatTabVisibility", {
      name: game.i18n.localize("changeLog.settings.chatTabVisibility.name"),
      hint: game.i18n.localize("changeLog.settings.chatTabVisibility.hint"),
      scope: "world",
      config: true,
      type: String,
      default: "both",
      choices: {
        none: game.i18n.localize("changeLog.settings.chatTabVisibility.none"),
        both: game.i18n.localize("changeLog.settings.chatTabVisibility.both"),
        exclusive: game.i18n.localize("changeLog.settings.chatTabVisibility.exclusive")
      },
      onChange: () => { game.changeLog.getChatTabVisibility(); }
    });

    /* -------------------------------------------- */

    game.settings.register(MODULE.ID, "chatTabRoles", {
      name: game.i18n.localize("changeLog.settings.chatTabRoles.name"),
      hint: game.i18n.localize("changeLog.settings.chatTabRoles.hint"),
      scope: "world",
      config: true,
      type: String,
      default: "all",
      choices: {
        all: game.i18n.localize("changeLog.settings.chatTabRoles.all"),
        gm: game.i18n.localize("changeLog.settings.chatTabRoles.gm"),
        trustedAndAbove: game.i18n.localize("changeLog.settings.chatTabRoles.trustedAndAbove"),
        assistantAndAbove: game.i18n.localize("changeLog.settings.chatTabRoles.assistantAndAbove")
      },
      onChange: () => { game.changeLog.getChatTabRoles(); }
    });
  }

  /* -------------------------------------------- */

  game.settings.register(MODULE.ID, "compactMode", {
    name: game.i18n.localize("changeLog.settings.compactMode.name"),
    hint: game.i18n.localize("changeLog.settings.compactMode.hint"),
    scope: "world",
    config: true,
    type: Boolean,
    default: false,
    onChange: () => { game.changeLog.getCompactMode(); }
  });

  /* -------------------------------------------- */

  game.settings.register(MODULE.ID, "showEquation", {
    name: game.i18n.localize("changeLog.settings.showEquation.name"),
    hint: game.i18n.localize("changeLog.settings.showEquation.hint"),
    scope: "world",
    config: true,
    type: Boolean,
    default: false,
    onChange: () => { game.changeLog.getShowEquation(); }
  });

  /* -------------------------------------------- */

  game.settings.register(MODULE.ID, "showSender", {
    name: game.i18n.localize("changeLog.settings.showSender.name"),
    hint: game.i18n.localize("changeLog.settings.showSender.hint"),
    scope: "world",
    config: true,
    type: Boolean,
    default: true,
    onChange: () => { game.changeLog.getShowSender(); }
  });

  /* -------------------------------------------- */

  game.settings.register(MODULE.ID, "showRecipients", {
    name: game.i18n.localize("changeLog.settings.showRecipients.name"),
    hint: game.i18n.localize("changeLog.settings.showRecipients.hint"),
    scope: "world",
    config: true,
    type: Boolean,
    default: true,
    onChange: () => { game.changeLog.getShowRecipients(); }
  });

  /* -------------------------------------------- */

  game.settings.register(MODULE.ID, "gmProperties", {
    name: "GM Properties",
    scope: "world",
    config: false,
    type: String,
    onChange: () => { game.changeLog.getGmProperties(); }
  });

  /* -------------------------------------------- */

  game.settings.register(MODULE.ID, "gmActorTypes", {
    name: "GM Actor Types",
    scope: "world",
    config: false,
    type: String,
    onChange: () => { game.changeLog.getGmActorTypes(); }
  });

  /* -------------------------------------------- */

  game.settings.register(MODULE.ID, "everyoneProperties", {
    name: "Everyone Properties",
    scope: "world",
    config: false,
    type: String,
    onChange: () => { game.changeLog.getEveryoneProperties(); }
  });

  /* -------------------------------------------- */

  game.settings.register(MODULE.ID, "everyoneActorTypes", {
    name: "Everyone Actor Types",
    scope: "world",
    config: false,
    type: String,
    onChange: () => { game.changeLog.getEveryoneActorTypes(); }
  });

  /* -------------------------------------------- */

  game.settings.register(MODULE.ID, "playerProperties", {
    name: "Player Properties",
    scope: "world",
    config: false,
    type: String,
    onChange: () => { game.changeLog.getPlayerProperties(); }
  });
};
